export const ADD_TAG_STARTING = 'ADD_TAG_STARTING';
export const ADD_TAG = 'ADD_TAG';
export const REMOVE_TAG_STARTING = 'REMOVE_TAG_STARTING';
export const REMOVE_TAG = 'REMOVE_TAG';
export const CLEAR_STORES = 'CLEAR_STORES';
export const GET_TAGS = 'GET_TAGS';
export const LOG_OUT = 'LOG_OUT';
export const DELETING_TAG = 'DELETING_TAG';
export const DELETED_TAG = 'DELETED_TAG';



// WEBPACK FOOTER //
// ./src/app/stores/tags/tags-constants.js